import { render, staticRenderFns } from "./modal-change-supervisor.vue?vue&type=template&id=25bc7203&scoped=true"
import script from "./modal-change-supervisor.vue?vue&type=script&lang=js"
export * from "./modal-change-supervisor.vue?vue&type=script&lang=js"
import style0 from "./modal-change-supervisor.vue?vue&type=style&index=0&id=25bc7203&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bc7203",
  null
  
)

export default component.exports